import { render } from "./ButtonCircle.vue?vue&type=template&id=212db552"
import script from "./ButtonCircle.vue?vue&type=script&lang=js"
export * from "./ButtonCircle.vue?vue&type=script&lang=js"

import "./ButtonCircle.vue?vue&type=style&index=0&id=212db552&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__